import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

export default class extends BridgeComponent {
    static component = 'download-image'
    static values = { url: String }

    async download({ currentTarget: button }) {
        const url = this.urlValue
        if (!url || button.disabled) return

        // Optimistic UI Update
        button.disabled = true
        button.dataset.state = 'success'

        let data, mimeType
        try {
            const response = await fetch(url)
            if (!response.ok) {
                throw new Error(`Failed to download image: HTTP ${response.status}`)
            }

            const blob = await response.blob()
            if (!blob.type || !blob.type.startsWith('image/')) {
                throw new Error(`Invalid image content type: ${blob.type || 'unknown'}`)
            }

            data = await this.#toBase64(blob)
            mimeType = blob.type
        } catch {
            this.#setError(button)
            return
        }

        this.send('download', { data, mimeType }, (reply) => {
            if (reply?.data?.success === false) {
                this.#setError(button)
            } else {
                setTimeout(() => {
                    button.dataset.state = ''
                    button.disabled = false
                }, 2500)
            }
        })
    }

    #setError(button) {
        button.dataset.state = 'error'
        setTimeout(() => {
            button.dataset.state = ''
            button.disabled = false
        }, 2500)
    }

    #toBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result.split(',')[1])
            reader.onerror = reject
            reader.readAsDataURL(blob)
        })
    }
}
